import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { useField } from 'formik';
import { RadioButton } from 'react-native-paper';
// Common component
import { LabeledField } from '../components/LabeledField';
import { theme } from '../theme';
export const ActivationFieldContent = ({ errors, width, duration, readOnly, showWeekStartsOn = false }) => {
    return (<View style={{ width: width }}>
      <View style={styles.row}>
        <View style={styles.fieldWrapper}>
          <LabeledField name="lossDays" label="Loss days" width={50} keyboardType="numeric" readOnly={readOnly}/>
        </View>
        <View style={styles.fieldWrapper}>
          <LabeledField name="mainteanceDays" label="Maintenance days" width={50} keyboardType="numeric" readOnly={readOnly}/>
        </View>
        <View style={styles.fieldWrapper}>
          <LabeledField name="rewardDays" label="Reward days" width={50} keyboardType="numeric" readOnly={true}/>
        </View>
      </View>
      {!!errors.totalDays && (<Text style={styles.required}>{errors.totalDays}</Text>)}
      <View style={styles.row}>
        <View style={styles.fieldWrapper}>
          <LabeledField name="startDate" label="Start date" placeholder="MM-DD-YYYY" width={120} keyboardType="string" readOnly={readOnly}/>
        </View>
        <View style={styles.fieldWrapper}>
          <LabeledField name="endDate" label="End date" placeholder="MM-DD-YYYY" width={120} keyboardType="string" readOnly={readOnly}/>
        </View>
        <View style={styles.fieldWrapper}>
          {duration !== undefined && duration > 0 && (<Text style={styles.durationText}>{`${duration} days`}</Text>)}
        </View>
      </View>
      {showWeekStartsOn ? <WeekStartsOnField readOnly={readOnly}/> : null}
      {!!errors.weekStartsOn && (<Text style={styles.required}>{String(errors.weekStartsOn)}</Text>)}
      <View style={styles.fieldWrapper}>
        <LabeledField name="plan" label="Plan" placeholder="Describe exchange details" width={380} keyboardType="string" readOnly={readOnly}/>
      </View>
    </View>);
};
const WeekStartsOnField = ({ readOnly }) => {
    const [field, , helpers] = useField('weekStartsOn');
    return (<View style={styles.weekStartBlock}>
      <Text style={styles.weekStartLabel}>Week starts on</Text>
      <Text style={styles.weekStartHint}>
        Defines which days are loss days for the program pattern. Can be changed
        later on this client’s CRM panel.
      </Text>
      <RadioButton.Group onValueChange={value => {
            if (!readOnly) {
                helpers.setValue(Number(value));
            }
        }} value={field.value === 0 || field.value === 1 ? String(field.value) : ''}>
        <View style={[
            styles.radioRow,
            readOnly ? styles.pointerEventsNone : styles.pointerEventsAuto,
        ]}>
          <View style={styles.radioItem}>
            <RadioButton value="1"/>
            <Text style={styles.radioItemText}>Monday</Text>
          </View>
          <View style={styles.radioItem}>
            <RadioButton value="0"/>
            <Text style={styles.radioItemText}>Sunday</Text>
          </View>
        </View>
      </RadioButton.Group>
    </View>);
};
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
    },
    fieldWrapper: {
        flex: 1,
        marginHorizontal: 4,
    },
    required: {
        color: theme.colors.dangerText,
    },
    durationText: {
        marginTop: 44,
        fontStyle: 'italic',
    },
    weekStartBlock: {
        marginTop: 12,
        marginHorizontal: 4,
    },
    weekStartLabel: {
        fontWeight: 'bold',
        marginBottom: 4,
    },
    weekStartHint: {
        fontSize: 12,
        color: theme.colors.textSecondary,
        marginBottom: 4,
    },
    radioRow: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    radioItem: {
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: 16,
    },
    radioItemText: {
        marginTop: 2,
    },
    pointerEventsNone: { pointerEvents: 'none' },
    pointerEventsAuto: { pointerEvents: 'auto' },
});
